<div class="d-flex flex-column flex-fill dx-card">
    <div class="flex-row flex-fill d-flex">
        <div class="d-flex flex-fill flex-column col-sm-6 pt-3 pb-2 px-2">
            @if (dayEntries) {
                <h4>Single Day - {{ displayDate }}</h4>
            }

            <div class="d-flex mb-4">
                <div class="d-flex flex-column ms-3">
                    <dx-date-box [(value)]="dayFilter.date" [width]="'150px'" (onValueChanged)="dayFilterChangeDate(0)"> </dx-date-box>
                </div>
                <div class="d-flex flex-column ms-3">
                    <div class="d-flex">
                        <button
                            class="btn btn-sm btn-secondary"
                            style="min-width: 100px"
                            (click)="dayFilterChangeDate(-1)"
                            [disabled]="!dayFilter.date"
                        >
                            Previous
                        </button>
                        <button
                            class="btn btn-sm btn-secondary ms-2"
                            style="min-width: 100px"
                            (click)="dayFilterChangeDate(1)"
                            [disabled]="!dayFilter.date"
                        >
                            Next
                        </button>
                        <button class="btn btn-sm btn-primary ms-4" style="min-width: 100px" (click)="getData()">Search</button>
                    </div>
                </div>
            </div>

            <dx-data-grid
                #dayGrid
                keyExpr="id"
                class="flex-fill d-flex flex-column"
                height="350px"
                [dataSource]="dayEntries"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                [columnAutoWidth]="false"
                (onRowDblClick)="rowDoubleClick($event)"
            >
                <dxi-data-grid-column dataField="entryDate" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="user.displayName" caption="User" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="timeType.name" caption="Time Type" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="timeType.pTO" caption="PTO" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="duration" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="description" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="note" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column></dxi-data-grid-column>

                <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
                <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                <dxo-data-grid-state-storing
                    [enabled]="true"
                    type="localStorage"
                    storageKey="day-time-overview-grid"
                ></dxo-data-grid-state-storing>
                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button class="btn btn-success me-2 mb-2" (click)="open()">Add</button>
                    <button
                        class="btn btn-primary me-2 mb-2"
                        (click)="open(dayGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dayGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Edit
                    </button>
                    <button
                        class="btn btn-danger mb-2"
                        (click)="delete(dayGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dayGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Delete
                    </button>
                </div>
            </dx-data-grid>
        </div>
        <div class="d-flex flex-fill flex-column col-sm-6 pt-3 pb-2 px-2">
            <h4>Week</h4>
            <dx-form [formData]="weekFilter" style="max-width: 400px" [colCount]="6">
                <dxi-form-item dataField="startDate" editorType="dxDateBox" [colSpan]="3"></dxi-form-item>
                <dxi-form-item dataField="endDate" editorType="dxDateBox" [colSpan]="3"></dxi-form-item>
                <dxi-form-item [colSpan]="2">
                    <button class="btn btn-secondary mt-2" (click)="previousWeek()" [disabled]="!weekFilter.startDate">
                        Previous Week
                    </button>
                </dxi-form-item>
                <dxi-form-item [colSpan]="2">
                    <button class="btn btn-secondary mt-2" (click)="nextWeek()" [disabled]="!weekFilter.startDate">Next Week</button>
                </dxi-form-item>
                <dxi-form-item [colSpan]="2">
                    <button class="btn btn-primary mt-2" (click)="getData()">Search</button>
                </dxi-form-item>
            </dx-form>
            <dx-data-grid
                #weekGrid
                keyExpr="id"
                class="flex-fill d-flex flex-column"
                height="350px"
                [dataSource]="weekEntries"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                [columnAutoWidth]="false"
            >
                <dxi-data-grid-column dataField="displayName" caption="User" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="regularHours" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="pTOHours" caption="PTO Hours" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="totalHours" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column></dxi-data-grid-column>

                <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
                <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                <dxo-data-grid-state-storing
                    [enabled]="true"
                    type="localStorage"
                    storageKey="week-time-overview-grid"
                ></dxo-data-grid-state-storing>
                <div *dxTemplate="let data of 'toolbarButtons'"></div>
            </dx-data-grid>
        </div>
    </div>
</div>
